import { createBrowserRouter } from 'react-router-dom'
import { SiteLayout } from '@/components/layout/SiteLayout'
import { ProjectModal } from '@/components/projects/ProjectModal'
import { AboutPage } from '@/pages/AboutPage'
import { ContactPage } from '@/pages/ContactPage'
import { HomePage } from '@/pages/HomePage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { ProjectsPage } from '@/pages/ProjectsPage'

/**
 * `/projects/:slug` is a *child* of `/projects`, so the modal renders through
 * the grid's `<Outlet />`. That single fact gives us three things for free:
 * every project has a shareable URL, a deep link paints the grid behind the
 * dialog, and the back button closes it.
 */
export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <SiteLayout />,
      children: [
        { index: true, element: <HomePage /> },
        {
          path: 'projects',
          element: <ProjectsPage />,
          children: [{ path: ':slug', element: <ProjectModal /> }],
        },
        { path: 'about', element: <AboutPage /> },
        { path: 'contact', element: <ContactPage /> },
        { path: '*', element: <NotFoundPage /> },
      ],
    },
  ],
  // Keeps routing correct when the site is served from a subpath.
  { basename: import.meta.env.BASE_URL },
)
